import { z } from "zod";

import ChatMarkdown from "@/components/ui/chat/ChatMarkdown";

/** Chat catalog definition for Markdown prose. Use in renderer catalog. */
export const ChatMarkdownSpec = {
  props: z.object({
    /** GitHub-flavoured markdown source rendered as prose. */
    content: z.string(),
  }),
  description:
    "Rich text block rendered as markdown (headings, paragraphs, lists, bold/italic, links, tables). Use for section headings, intros, and body copy.",
  example: {
    content:
      "## Executive summary\n\nCoverage grew **32%** week over week, led by product launch stories.\n\n- Sentiment stayed net positive\n- Three new tier-1 outlets picked up the story",
  },
} as const;

type MarkdownPropsFromSpec = {
  content: string;
};

/**
 * Adapter for json-render defineRegistry: renders {@link ChatMarkdown} from catalog props.
 */
export const ChatMarkdownFromProps = ({
  props,
}: {
  props: Record<string, unknown>;
}) => {
  const { content } = props as MarkdownPropsFromSpec;
  return <ChatMarkdown>{content}</ChatMarkdown>;
};
